module.exports = __webpack_public_path__ + "img/04.f7a966fd.png";